// @ts-nocheck
import { FeatureFlagsSettings } from "@store/Framework/Types/ApiModels";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";

/**
 * Hard-typed set of storefront feature flags.
 * Extends the FeatureFlags settings contract so every flag exposed by the backend is
 * usable here automatically. Add flags that are not (yet) served by that API below.
 */
export interface FeatureFlags extends FeatureFlagsSettings {}

export type FeatureFlagName = keyof FeatureFlags;

/**
 * Central accessor for storefront feature flags.
 * Falls back to false when the settings collection has not loaded yet or the flag is absent.
 */
const useFeatureFlag = (flagName: FeatureFlagName): boolean => {
    const featureFlags: Partial<FeatureFlags> | undefined = useSettingsCollection().featureFlagsSettings;
    return featureFlags?.[flagName] ?? false;
};

export default useFeatureFlag;
